import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDeskOffice2"><Path fillRule="evenodd" clipRule="evenodd" d="M5 3H15V10H10.75V11H21V21H12V12.5H4.5V21H3V11H9.25V10H5V3ZM19.5 12.5V15.25H13.5V12.5H19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDeskOffice2;
